/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SiteSection({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M14 1.398a1.6 1.6 0 0 1 1.6 1.6v10a1.6 1.6 0 0 1-1.6 1.6H2a1.6 1.6 0 0 1-1.6-1.6v-10a1.6 1.6 0 0 1 1.6-1.6zm-12 1.2a.4.4 0 0 0-.4.4v10c0 .221.18.4.4.4h12a.4.4 0 0 0 .4-.4v-10a.4.4 0 0 0-.4-.4zM8 4.4a.6.6 0 1 1 0 1.2H4a.6.6 0 1 1 0-1.2z" /></svg>;
}
;